import React from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { Tooltip } from '@material-ui/core';
import { CommonConfig } from '../../../../config/common-config';
import downloadImage from '../../../../assets/downloadImage.png';


// const styles = (theme) => ({
//     root: {
//         margin: 0,
//         padding: theme.spacing(2),
//         textAlign: 'center',
//     },
//     closeButton: {
//         position: 'absolute',
//         right: theme.spacing(1),
//         top: theme.spacing(1),
//         color: theme.palette.grey[500],
//     },
// });

// const useStyles = makeStyles((theme) => ({
//     dialogPaper: {
//         minHeight: '100vh',
//         maxHeight: '100vh',
//     },
//     actionDisplay: {
//         display: 'contents'
//     },
//     btn: {
//         color: 'white !important',
//         fontSize: '14px !important',
//         background: '#3f51b5 !important',
//         fontFamily: 'Rubik',
//         fontWeight: '400 !important',
//         borderRadius: '6px',
//         letterSpacing: 'normal',
//         textTransform: 'capitalize',
//         cursor: 'pointer',
//         margin: '5px !important',
//     },
//     center: {
//         textAlign: 'center',
//     },
//     textArea: {
//         display: 'inline-flex',
//         resize: 'none',
//         marginLeft: '60px',
//     },
//     textarea1: {
//         marginRight: '60px',
//         resize: 'none',
//     },
//     textarea2: {
//         marginLeft: '50px',
//         resize: 'none',
//     },

// }));


export const Download = ({ Icon, row }) => {
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantname = tennantDetails.tennantName && tennantDetails.tennantName;
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;

    const handleClickOpen = () => {
        let serviceIdValue = row.serviceId
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/mergedpdffile/${serviceIdValue}/${tennantname}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                //console.log("response", response);
                const link = document.createElement('a');
                link.href = response.config.url;
                link.setAttribute('download', response.config.url);
                link.click();
            })
            .catch(() => {
            });
    };

    return (
        <>
            {Icon === 'download' && (
                <span style={{ marginTop: '-4px', marginRight: '6px' }} onClick={handleClickOpen}>
                    <Tooltip title="Download">
                        <img src={downloadImage} alt="downloadImage" className="downlaodImg downloadImgTop" />
                    </Tooltip>
                </span>
            )}
        </>
    );
};

